import service from './request'

export function getAllOptions() {
    return service.get(`/options`)
}

export function getOptions(type, param = null) {
    return service.get(`/options/${type}`, param)
}
